module.exports = __webpack_public_path__ + "assets/0743b7b4ba109064ec48ec8dd6eb932d.png";